module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isView),
      expression: "!isView"
    }],
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12",
      "sm": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaignList,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n            " + _vm._s(item.name) + "  \n            "), (item.lockedCOGS) ? _c('v-chip', {
          attrs: {
            "color": "error",
            "small": ""
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#fff"
          }
        }, [_c('v-icon', _vm._g({
          attrs: {
            "small": "",
            "left": ""
          }
        }, _vm.on), [_vm._v("mdi-lock")]), _vm._v(" Locked COGS")], 1)]) : _vm._e()], 1)]
      }
    }]),
    model: {
      value: (_vm.campaignID),
      callback: function($$v) {
        _vm.campaignID = $$v
      },
      expression: "campaignID"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 secondary",
    staticStyle: {
      "height": "56px"
    },
    attrs: {
      "disabled": !_vm.campaignCOEB.campaignId,
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.refreshPairingInfFromIMS(_vm.campaignCOEB)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-cached")]), _vm._v(" Refresh\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-row', [(_vm.campaignCOEB) ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#CFD8DC"
    }
  }, [_c('v-card-subtitle', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          Campaign Name: " + _vm._s(_vm.campaignCOEB.campaignName || 'N/A') + "\n          "), (_vm.campaignCOEB.lockedCOGS) ? _c('v-chip', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": "",
      "left": ""
    }
  }, _vm.on), [_vm._v("mdi-lock")]), _vm._v("Locked COGS")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isAdmin && _vm.disableLockedCOGS) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openLockedCOGSDialog(_vm.campaignCOEB)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock-open")]), _vm._v(" Request Unlock\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin && _vm.disableLockedCOGS && !_vm.isView) ? _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.changeLock(_vm.campaignCOEB, false)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock-open")]), _vm._v(" Unlock\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.showLockBtn) ? _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.changeLock(_vm.campaignCOEB, true)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock")]), _vm._v(" Lock\n          ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n          Client Name: " + _vm._s(_vm.campaignCOEB.clientName || 'N/A') + "\n        ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pt-2"
  }, [_vm._v("\n          IO Number: " + _vm._s(_vm.campaignCOEB.ioNumbers || 'N/A') + "\n        ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignCOEB.min_content) + " to " + _vm._s(_vm.campaignCOEB.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), (_vm.measurement.totalPercentage && _vm.measurement.totalPercentage !== 'NaN' && _vm.measurement.totalPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), (_vm.measurement.outreachPercentage && _vm.measurement.outreachPercentage !== 'NaN' && _vm.measurement.outreachPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), (_vm.measurement.engagementPercentage && _vm.measurement.engagementPercentage !== 'NaN' && _vm.measurement.engagementPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Budget")]), _vm._v(" "), _c('v-card-subtitle', [(_vm.budget) ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("currency")(_vm.budget)))]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : 0")]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), (_vm.measurement.cogsPercentage && _vm.measurement.cogsPercentage !== 'NaN' && _vm.measurement.cogsPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 flex-row-reverse",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "8",
      "lg": "8"
    }
  }, [(_vm.selectedItems && _vm.selectedItems.length > 0) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openMultipleEstimatedLiveDateDialog()
      }
    }
  }, [_vm._v("Update Estimated Live Month (" + _vm._s(_vm.selectedItems.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.selectedItems && _vm.selectedItems.length > 0) ? _c('v-btn', {
    staticClass: "ml-2 secondary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openMultipleSubmissionDateDialog()
      }
    }
  }, [_vm._v("Update Submission Date (" + _vm._s(_vm.selectedItems.length) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.briefConfirmationSearch),
      callback: function($$v) {
        _vm.briefConfirmationSearch = $$v
      },
      expression: "briefConfirmationSearch"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1 page__table",
    attrs: {
      "headers": _vm.computedPairedHeaders,
      "items": _vm.pairedInfluencers,
      "items-per-page": 10,
      "search": _vm.briefConfirmationSearch,
      "no-data-text": 'Empty list',
      "show-select": "",
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllItems
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', [(props.items && props.items.length === 0) ? _c('tr', [_c('td', [_vm._v("No Data")])]) : _vm._e(), _vm._v(" "), _vm._l((props.items), function(item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', {
            staticStyle: {
              "min-width": "100px",
              "padding": "0 14px!important"
            }
          }, [_c('v-checkbox', {
            staticClass: "multi-select-checkbox",
            staticStyle: {
              "padding-left": "18px"
            },
            attrs: {
              "label": "",
              "color": "grey darken-2"
            },
            on: {
              "change": _vm.actionSelectChange
            },
            model: {
              value: (item.isSelected),
              callback: function($$v) {
                _vm.$set(item, "isSelected", $$v)
              },
              expression: "item.isSelected"
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "invoice-handle-column"
          }, [_c('div', {
            staticClass: "d-flex align-center"
          }, [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.influencer_details.platform === 'tiktok',
              "isInstagram": !item.influencer_details.platform || item.influencer_details.platform === 'instagram',
              "isFacebook": item.influencer_details.platform === 'facebook',
              "isLinkedIn": item.influencer_details.platform === 'linkedin',
              "isTwitter": item.influencer_details.platform === 'twitter',
              "isYoutube": item.influencer_details.platform === 'youtube',
              "isXiaohongshu": item.influencer_details.platform === 'xiaohongshu',
              "isOthers": item.influencer_details.platform === 'others',
              "tiktokHandle": item.influencer_details.instagramHandle,
              "instagramHandle": item.influencer_details.instagramHandle,
              "facebookHandle": _vm.getFacebookHandle(item.influencer_details),
              "linkedinHandle": item.influencer_details.linkedinHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle,
              "twitterHandle": item.influencer_details.twitterHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle,
              "youtubeHandle": item.influencer_details.instagramHandle,
              "otherHandle": item.influencer_details.instagramHandle,
              "xiaohongshuHandle": item.influencer_details.xhsID,
              "xiaohongshuFullName": item.influencer_details.fullName,
              "youtubeURL": item.influencer_details.url
            }
          }), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "padding": "0",
                    "margin-left": "-9px",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        staticClass: "ml-2",
                        attrs: {
                          "color": "secondary",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.linkedin) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#0A66C2",
                "small": ""
              }
            }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.twitter) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/x-logo.svg",
                "width": "15px",
                "alt": "",
                "aria-hidden": "true"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e(), _vm._v(" "), (item.influencer_details.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "green"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("done")])]
              }
            }], null, true)
          }, [_c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (!item.influencer_details.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "red"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_c('span', [_vm._v("Not in IMS")])]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
            staticClass: "invoice-platform-column"
          }, [_c('span', [_vm._v(_vm._s(_vm._f("platformDisplayName")(item.platformName)))])]), _vm._v(" "), _c('td', [(item.influencer_details.followers !== undefined && item.influencer_details.followers !== null) ? _c('span', [_vm._v(_vm._s(item.influencer_details.followers))]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', [(item.influencer_details.platform !== 'facebook' && item.engagement_rate !== '0.00' && item.engagement_rate) ? _c('span', [_vm._v(_vm._s(item.influencer_details.engagement_rate) + "%")]) : (item.engagement_rate === '0.00') ? _c('span', {
            staticClass: "caption"
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Hidden"
            }
          }, [_vm._v("mdi-eye-off")])], 1) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', [_c('v-icon', {
            attrs: {
              "color": item.influencer_details.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")]), _vm._v("\n                " + _vm._s(item.influencer_details.audience_credibility) + "\n              ")], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDeliverableCounts(item.deliverablesDisplay)))]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(item.payoutAmount))])])], 1)]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [(item.GSTpercent) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                      " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")((item.payoutAmount - item.GSTpercent))) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")((item.payoutAmount - item.GSTpercent))))])])], 1) : _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt))]) : _vm._e()])], 1)]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [(item.GSTIncluded) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.GSTpercent)) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.GSTpercent)))])])], 1) : _vm._e()]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                " + _vm._s(_vm.formatSubmissionDate(item.pairing_details.submission_date)) + "\n                "), _c('v-btn', _vm._g(_vm._b({
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.isView),
              expression: "!isView"
            }],
            attrs: {
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.openUpdateSubmissionDialog(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" "), _c('span', [_vm._v("Update Date")])], 1)], 1), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                " + _vm._s(_vm.formatLiveMonth(item.pairing_details.estimatedLiveDate)) + "\n                "), _c('v-btn', _vm._g(_vm._b({
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.isView),
              expression: "!isView"
            }],
            attrs: {
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.openEstimatedLiveDateDialog(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" "), _c('span', [_vm._v("Update Date")])], 1)], 1), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.isView),
              expression: "!isView"
            }]
          }, [_c('v-btn', {
            attrs: {
              "color": "primary",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.viewClick(item, 0)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "secondary",
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" Edit Invoice\n                ")], 1), _vm._v(" "), _c('v-btn', {
            staticClass: "mt-1",
            attrs: {
              "color": "primary",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.viewClick(item, 1)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "secondary",
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" Edit Brief\n                ")], 1)], 1), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.isView),
              expression: "!isView"
            }]
          }, [_c('div', [_c('div', [(item.contact_details && item.contact_details.email && _vm.isCampaignAM && _vm.isCampaignCC && !item.signinForm && item.pairing_details.estimatedLiveDate) ? _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "secondary",
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.copySignInFormLink(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy link")])], 1) : _vm._e(), _vm._v(" "), (item.contact_details && !item.contact_details.email) ? _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "secondary",
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.openUpdateEmailDialog(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "color": "secondary",
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" "), _c('span', [_vm._v("Update Email")])], 1) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.isCampaignAM || !_vm.isCampaignCC) ? _c('v-btn', {
            staticClass: "assign-am-cc-btn mt-2 mb-2 black--text",
            attrs: {
              "small": "",
              "depressed": "",
              "color": "yellow"
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-alert-circle")]), _vm._v("\n                        Assign "), (!_vm.isCampaignAM) ? _c('span', [_vm._v("AM")]) : _vm._e(), (!_vm.isCampaignCC && !_vm.isCampaignCC) ? _c('span', [_vm._v(",")]) : _vm._e(), (!_vm.isCampaignCC) ? _c('span', [_vm._v("CC")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.signingFormsForDownload(item).length) ? _c('div', {
            staticClass: "pt-1"
          }, [_c('v-menu', {
            attrs: {
              "offset-y": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "mb-1",
                  attrs: {
                    "color": "success",
                    "small": "",
                    "text": ""
                  }
                }, 'v-btn', _vm.attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-download")]), _vm._v(" Download\n                          ")], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.signingFormsForDownload(item)), function(invoice, i) {
            return _c('v-list-item', {
              key: invoice.contractFile.url || i,
              attrs: {
                "href": invoice.contractFile.url,
                "target": "_blank"
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(_vm.utilsFunc.formatCustomDate(invoice.contractFile.timestamp || invoice.createdAt, 'DD/MM/YYYY hh:mm:ss A')))])], 1)
          }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!item.signinForm && !item.pairing_details.estimatedLiveDate) ? _c('span', [_vm._v("(Please update estimate live month)")]) : _vm._e()], 1)])]), _vm._v(" "), _c('td', [_c('div', [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "secondary",
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.copyContentScriptFormLink(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy link")])], 1)], 1)]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.isView),
              expression: "!isView"
            }]
          }, [_c('v-btn', {
            staticClass: "mb-1",
            attrs: {
              "color": "success",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.viewClick(item, 2)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-send")]), _vm._v(" Preview and Send\n                ")], 1), _vm._v(" "), (item.payout_details && item.payout_details.status !== _vm.payoutStatus.CONFIRMED) ? _c('v-btn', {
            staticClass: "mb-1",
            attrs: {
              "color": "success",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.confirmPayout(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-check")]), _vm._v(" Confirm Payout\n                ")], 1) : _vm._e(), _vm._v(" "), (item.payout_details && item.payout_details.status === _vm.payoutStatus.CONFIRMED) ? _c('v-btn', {
            staticClass: "mb-1",
            attrs: {
              "color": "error",
              "small": "",
              "disabled": _vm.disableLockedCOGS
            },
            on: {
              "click": function($event) {
                return _vm.cancelPayout(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-cancel")]), _vm._v(" Cancel Payout\n                ")], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.sentStatus === _vm.pairingSendStatus.DRAFT) ? _c('v-chip', {
            attrs: {
              "color": "info",
              "outlined": "",
              "small": ""
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("new_releases")]), _vm._v("  " + _vm._s(_vm.pairingSendStatusDisplay[item.sentStatus]) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (item.sentStatus === _vm.pairingSendStatus.SENT) ? _c('v-chip', {
            attrs: {
              "color": "green",
              "outlined": "",
              "small": ""
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("done")]), _vm._v("  " + _vm._s(_vm.pairingSendStatusDisplay[item.sentStatus]) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (item.sentStatus === _vm.pairingSendStatus.SIGNED) ? _c('v-chip', {
            attrs: {
              "color": "green",
              "outlined": "",
              "small": ""
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("done")]), _vm._v("  " + _vm._s(_vm.pairingSendStatusDisplay[item.sentStatus]) + "\n                ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "mt-1 mb-1"
          }, [((item.payout_details && item.payout_details.status !== _vm.payoutStatus.CONFIRMED) && (item.pairingStatus && item.pairingStatus === _vm.pairingStatus.ACCEPTED.value) && !_vm.isView) ? _c('v-btn', {
            staticClass: "mb-1",
            attrs: {
              "color": "error",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.cancelAccept(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-close")]), _vm._v(" Remove\n                  ")], 1) : _vm._e()], 1)], 1)])
        })], 2)]
      }
    }]),
    model: {
      value: (_vm.selectedItems),
      callback: function($$v) {
        _vm.selectedItems = $$v
      },
      expression: "selectedItems"
    }
  })], 1)], 1), _vm._v(" "), _c('influencer-detail-modal', {
    attrs: {
      "dialog": _vm.dialog,
      "influencer": _vm.influencer,
      "influencerProfile": _vm.influencerProfile,
      "selectedTab": _vm.selectedTab,
      "briefDetailContent": _vm.briefDetailsHTML,
      "close": _vm.closeModal,
      "newPairingFlow": true,
      "isDownload": _vm.invoiceDownload,
      "isFinalPayout": _vm.isFinalPayout
    },
    on: {
      "loadInfluencer": _vm.loadInfluencerData,
      "reRenderDatTable": _vm.loadInfluencerData,
      "loadingDialogOpen": _vm.loadingDialogOpen,
      "loadingDialogClose": _vm.loadingDialogClose
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-link"
    },
    domProps: {
      "value": _vm.signinFormLink
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-concept-link"
    },
    domProps: {
      "value": _vm.conceptFormLink
    }
  }), _vm._v(" "), _c('view-signin-form-modal', {
    attrs: {
      "value": _vm.viewSigninFormModalDialog,
      "signinFormData": _vm.viewSigninFormData
    },
    model: {
      value: (_vm.viewSigninFormModalDialog),
      callback: function($$v) {
        _vm.viewSigninFormModalDialog = $$v
      },
      expression: "viewSigninFormModalDialog"
    }
  }), _vm._v(" "), _c('update-creator-email-modal', {
    attrs: {
      "value": _vm.updateCreatorEmailDialog,
      "pairing": _vm.viewPairingData
    },
    on: {
      "updated": _vm.loadInfluencerData
    },
    model: {
      value: (_vm.updateCreatorEmailDialog),
      callback: function($$v) {
        _vm.updateCreatorEmailDialog = $$v
      },
      expression: "updateCreatorEmailDialog"
    }
  }), _vm._v(" "), _c('update-submission-date-modal', {
    attrs: {
      "value": _vm.updateSubmissionDateDialog,
      "pairing": _vm.viewPairingData
    },
    on: {
      "updated": _vm.loadInfluencerData
    },
    model: {
      value: (_vm.updateSubmissionDateDialog),
      callback: function($$v) {
        _vm.updateSubmissionDateDialog = $$v
      },
      expression: "updateSubmissionDateDialog"
    }
  }), _vm._v(" "), _c('estimated-live-date-modal', {
    attrs: {
      "value": _vm.updateEstimatedLiveDateDialog,
      "pairing": _vm.viewPairingData,
      "multiplePairings": _vm.multiplePairings
    },
    on: {
      "updated": _vm.loadInfluencerData
    },
    model: {
      value: (_vm.updateEstimatedLiveDateDialog),
      callback: function($$v) {
        _vm.updateEstimatedLiveDateDialog = $$v
      },
      expression: "updateEstimatedLiveDateDialog"
    }
  }), _vm._v(" "), _c('submission-date-modal', {
    attrs: {
      "value": _vm.updateMultipleSubmissionDateDialog,
      "pairing": _vm.viewPairingData,
      "multiplePairings": _vm.multiplePairings
    },
    on: {
      "updated": _vm.loadInfluencerData
    },
    model: {
      value: (_vm.updateMultipleSubmissionDateDialog),
      callback: function($$v) {
        _vm.updateMultipleSubmissionDateDialog = $$v
      },
      expression: "updateMultipleSubmissionDateDialog"
    }
  }), _vm._v(" "), (_vm.viewContentScriptsData) ? _c('view-creator-concept-modal-dialog', {
    attrs: {
      "value": _vm.viewcontentScriptModalDialog,
      "data": _vm.viewContentScriptsData
    },
    model: {
      value: (_vm.viewcontentScriptModalDialog),
      callback: function($$v) {
        _vm.viewcontentScriptModalDialog = $$v
      },
      expression: "viewcontentScriptModalDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.copySucceeded),
      callback: function($$v) {
        _vm.copySucceeded = $$v
      },
      expression: "copySucceeded"
    }
  }, [_vm._v("\n    Copied to Clipboard!\n    "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.copySucceeded = false
      }
    }
  }, [_vm._v("\n      Close\n    ")])], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed26fafa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/InvoicesBriefConfirmation.vue
// module id = 2312
// module chunks = 0